"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Slide_vue_1 = tslib_1.__importDefault(require("./Slide.vue"));
const RememberDevice_vue_1 = tslib_1.__importDefault(require("./RememberDevice.vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const AuthenticationFactor_1 = require("../enums/AuthenticationFactor");
const ChallengeStatus_1 = require("../enums/ChallengeStatus");
const ChallengeType_1 = require("../enums/ChallengeType");
const sitetext_1 = require("../filters/sitetext");
const SlideHeader_vue_1 = tslib_1.__importDefault(require("./SlideHeader.vue"));
exports.default = vue_1.default.extend({
    name: 'token-stepup',
    props: {
        stepUpCategory: {
            type: Object,
            required: true,
        },
        tokenLength: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            tokenCode: '',
            isNavigatingBack: false,
            header: '',
            subtitle: '',
            clearError: false,
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        hasError() {
            return (!this.$data.clearError && this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        errorText() {
            return this.getSiteText(`ChallengeStatus.${this.$store.state.challengeStatus}`);
        },
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        inputHelperText() {
            const currentAuthenticationFactorValue = this.stepUpCategory.StepUpModel.AuthenticationFactorValue;
            let helperText = '';
            if (currentAuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.TOTP) {
                helperText = this.getSiteText('StepUp.TOTP.DisplayInput.HelperText');
            }
            else if (currentAuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.Token) {
                helperText = this.getSiteText('StepUp.Token.DisplayInput.HelperText');
            }
            return helperText;
        },
        isTOTP() {
            return this.stepUpCategory.StepUpModel.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.TOTP;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        elementId() {
            return this.isTOTP ? 'txt_TOTP' : 'txt_Token';
        },
        hasServerError() {
            return this.$store.state.errors.length > 0;
        },
    },
    methods: {
        tokenCodeUpdated(value) {
            this.$data.tokenCode = value;
        },
        onFocus() {
            this.$data.clearError = true;
        },
        async navigateBack() {
            if (this.isNavigatingBack) {
                return;
            }
            this.isNavigatingBack = true;
            await this.$store.dispatch('goToPreviousChallenge');
            this.isNavigatingBack = false;
        },
        async verifyCode() {
            if (this.submitting) {
                return;
            }
            this.$data.clearError = false;
            const challenge = {
                ...this.currentChallenge,
                ValidationKey: this.$data.tokenCode,
                AuthenticationFactorValue: this.isTOTP ? AuthenticationFactor_1.AuthenticationFactor.TOTP : AuthenticationFactor_1.AuthenticationFactor.Token,
                // add remember device settings
                RememberDevice: this.$store.getters.rememberDevice,
                DeviceName: this.$store.getters.deviceName,
            };
            challenge.ProviderId = this.stepUpCategory.NextChallenge.ProviderId;
            challenge.ChallengeTypeValue = ChallengeType_1.ChallengeType.OneTimeCode;
            // set the state to remain on the same screen for invalid code
            this.$store.commit('setRemainOnStepUpScreenOnFailure', true);
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            await this.$store.dispatch('submitChallenge', challenge);
            // clear the code if error
            if (this.hasError) {
                this.tokenCodeUpdated('');
            }
        },
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        RememberDevice: RememberDevice_vue_1.default,
        SlideHeader: SlideHeader_vue_1.default,
    },
});
